import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  Grid,
  Typography,
  styled,
  useTheme,
} from "@mui/material";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { CustomDialog, CustomReactSelect, CustomTextField } from "../../index";
import subjectAdminServices from "../../../services/subject/admin";
import { toast } from "react-toastify";
import issueAdminService from "../../../services/issue/admin";

const StyledBox = styled(Box)(({ theme }) => ({
  width: "100%",
  height: "100%",
  borderRadius: theme.borderRadius[10],
  padding: "25px",
  boxShadow: theme.boxShadow.shadowThree,
  marginBottom: "10px",
}));

function CreateIssue({
  open,
  setOpenCreateIssue,
  journalDetails,
  archiveDetails,
  issueDetails,
  setIssueDetails,
  setIssueList,
}) {
  const theme = useTheme();
  const [saveLoader, setSaveLoader] = useState(false);
  // const [selectedJournal, setSelectJournal] = useState("");
  const [journalOptions, setJournalOptions] = useState([]);
  const [archiveOptions, setArchiveOptions] = useState([]);

  const issueValidationSchema = yup.object().shape({
    name: yup.string().required("name is required"),
    journal: yup.mixed().required("journal is required"),
    archive: yup.mixed().required("archive is required"),
  });

  const {
    control,
    handleSubmit,
    formState: { errors },
    setError,
    setValue,
  } = useForm({
    defaultValues: {
      name: "",
      journal: "",
      archive: "",
    },
    resolver: yupResolver(issueValidationSchema),
  });

  const onSubmit = async ({ name, journal, archive }) => {
    setSaveLoader(true);
    const reqSaveIssue = {
      name: name,
      journal: journal?._id,
      archive: archive?._id,
      ...(issueDetails?._id && {
        issueId: issueDetails?._id,
      }),
    };
    const resSaveIssue = await issueAdminService.createIssue(reqSaveIssue);
    if (resSaveIssue) {
      toast.success("Issue save successful");
      setSaveLoader(false);
      setValue("name", "");
      setIssueList((prev) => ({ ...prev, refresh: !prev.refresh }));
      setOpenCreateIssue((prev) => !prev);
      setIssueDetails(null);
    } else {
      setSaveLoader(false);
      setError("name", { type: "custom", message: "Issue already exist" });
    }
  };

  useEffect(() => {
    if (issueDetails) {
      setValue("name", issueDetails.name);
    }
  }, [issueDetails, setValue]);

  useEffect(() => {
    setJournalOptions([journalDetails]);
    setValue("journal", journalDetails);
    setArchiveOptions([archiveDetails]);
    setValue("archive", archiveDetails);
  }, [journalDetails, setValue, archiveDetails]);

  return (
    <CustomDialog
      open={open}
      title={"Create Issue"}
      agreeButtonText={"Create"}
      agreeButtonProp={{
        variant: "contained",
        color: "secondary",
        type: "submit",
        endIcon: saveLoader && <CircularProgress size={20} />,
        disabled: saveLoader,
        onClick: handleSubmit(onSubmit),
        size: "small",
        sx: {
          "&.MuiButton-root": {
            color: theme.palette.neutral[0],
            // width: "100%",
            borderRadius: theme.borderRadius[10],
            textTransform: "none",
            "&:hover": {
              backgroundColor: theme.palette.secondary.hover,
            },
          },
        },
      }}
      cancelButtonText={"Cancel"}
      cancelButtonProp={{
        variant: "contained",
        color: "primary",
        type: "button",
        disabled: saveLoader,
        onClick: () => {
          setValue("name", "");
          setOpenCreateIssue((prev) => !prev);
          setIssueDetails(null);
        },
        size: "small",
        sx: {
          "&.MuiButton-root": {
            color: theme.palette.neutral[0],
            // width: "100%",
            borderRadius: theme.borderRadius[10],
            textTransform: "none",
            "&:hover": {
              backgroundColor: theme.palette.primary.hover,
            },
          },
        },
      }}
    >
      {/* <StyledBox> */}
      <form>
        <Grid container spacing={2} sx={{ marginTop: "10px" }}>
          <Grid item xs={12}>
            <Controller
              name="name"
              control={control}
              render={({ field }) => (
                <CustomTextField
                  label="Name *"
                  variant="outlined"
                  size="small"
                  type="text"
                  fullWidth
                  helperText={errors?.name?.message}
                  error={errors?.name?.message}
                  {...field}
                />
              )}
            />
          </Grid>
          <Grid item xs={12}>
            <Controller
              name="journal"
              control={control}
              render={({ field }) => (
                <CustomReactSelect
                  // label={"Subject"}
                  getOptionLabel={(e) => e.name}
                  getOptionValue={(e) => e.name}
                  options={journalOptions}
                  placeholder={"Select a journal"}
                  helperText={errors?.journal?.message}
                  error={errors?.journal?.message}
                  {...field}
                />
              )}
            />
          </Grid>
          <Grid item xs={12}>
            <Controller
              name="archive"
              control={control}
              render={({ field }) => (
                <CustomReactSelect
                  // label={"Subject"}
                  getOptionLabel={(e) => e.name}
                  getOptionValue={(e) => e.name}
                  options={archiveOptions}
                  placeholder={"Select a archive"}
                  helperText={errors?.archive?.message}
                  error={errors?.archive?.message}
                  {...field}
                />
              )}
            />
          </Grid>
        </Grid>
      </form>
      {/* </StyledBox> */}
    </CustomDialog>
  );
}

export default CreateIssue;
